
export enum DeviceApplicationCd {
	PDOPS = 'PDOPS',
	XDOCK = 'XDOCK'}

